export default __webpack_public_path__ + "static/media/loginpeople.9b19d394.svg";